import { useQuery } from '@tanstack/react-query';
import { sftpUsersKeys } from './sftp-users-keys';

/**
 * React Query hook: fetch a single SFTP user entity by id using prebuilt queryOptions.
 * Falls back to a disabled queryOptions when id is falsy.
 */
export function useSftpUserByIdQuery(id?: string) {
  return useQuery(sftpUsersKeys.byIdQuery(id));
}
